import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { FlaskConical, Flag, Plus, Users, BarChart3, TrendingUp } from 'lucide-react';
import ExperimentList from './ExperimentList';
import './ExperimentDashboard.css';

function ExperimentDashboard() {
  const [summary, setSummary] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    fetchSummary();
  }, []);

  const fetchSummary = async () => {
    try {
      setLoading(true);
      const response = await axios.get('/api/experiments/dashboard/summary');
      setSummary(response.data);
      setError(null);
    } catch (err) {
      console.error('Failed to fetch experiment summary:', err);
      setError('Failed to load dashboard data');
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="experiment-dashboard">
        <div className="exp-loading">
          <div className="spinner"></div>
          <p>Loading dashboard...</p>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="experiment-dashboard">
        <div className="exp-error">{error}</div>
      </div>
    );
  }

  return (
    <div className="experiment-dashboard">
      <div className="exp-page-header">
        <div>
          <h1>Experiments</h1>
          <p className="exp-page-subtitle">A/B tests and feature flags</p>
        </div>
        <div className="exp-header-actions">
          <button
            className="exp-btn-secondary"
            onClick={() => navigate('/experiments/flags')}
          >
            <Flag size={16} />
            Feature Flags
          </button>
          <button
            className="exp-btn-primary"
            onClick={() => navigate('/experiments/new')}
          >
            <Plus size={16} />
            New Experiment
          </button>
        </div>
      </div>

      <div className="exp-stat-cards">
        <div className="exp-stat-card">
          <div className="exp-stat-icon">
            <FlaskConical size={20} />
          </div>
          <div className="exp-stat-info">
            <div className="exp-stat-value">{summary?.running ?? 0}</div>
            <div className="exp-stat-label">Running Experiments</div>
          </div>
        </div>
        <div className="exp-stat-card">
          <div className="exp-stat-icon">
            <Users size={20} />
          </div>
          <div className="exp-stat-info">
            <div className="exp-stat-value">{(summary?.total_visitors ?? 0).toLocaleString()}</div>
            <div className="exp-stat-label">Total Visitors</div>
          </div>
        </div>
        <div className="exp-stat-card">
          <div className="exp-stat-icon">
            <TrendingUp size={20} />
          </div>
          <div className="exp-stat-info">
            <div className="exp-stat-value">{summary?.significant_results ?? 0}</div>
            <div className="exp-stat-label">Significant Results</div>
          </div>
        </div>
        <div className="exp-stat-card">
          <div className="exp-stat-icon">
            <Flag size={20} />
          </div>
          <div className="exp-stat-info">
            <div className="exp-stat-value">{summary?.active_flags ?? 0}</div>
            <div className="exp-stat-label">Active Flags</div>
          </div>
        </div>
      </div>

      <div className="exp-recent-section">
        <div className="exp-section-header">
          <h2>Recent Experiments</h2>
          <Link to="/experiments" className="exp-view-all">View All</Link>
        </div>
        <ExperimentList limit={10} embedded />
      </div>
    </div>
  );
}

export default ExperimentDashboard;
